"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![MaterializationIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOS42MyAxOC4yNCIgaGVpZ2h0PSIzMCIgd2lkdGg9IjMwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+TWF0ZXJpYWxpemVkVmlldzwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTUuMjUgMCAxOS40NyAwIDE3LjMzIDUuMTYgMTkuNjMgNS4xNiAxMC41IDE4LjI0IDE0LjQzIDguMzEgMTEuOTEgOC4zMSAxNS4yNSAwIi8+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTExLDE0LjMzSDguNVYxMC42OGg0bC4zOS0xSDguNVY2aDMuMzNMMTMuMSwyLjg3SDFhMSwxLDAsMCwwLTEsMVYxNC4zM2ExLDEsMCwwLDAsMSwxaDkuNjVabS0zLjU0LDBIMVYxMC42OEg3LjVabTAtNC42NUgxVjZINy41WiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.MaterializationIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 19.63 18.24", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M15.25 0h4.22l-2.14 5.16h2.3L10.5 18.24l3.93-9.93h-2.52L15.25 0z" }),
        React.createElement("path", { d: "M11 14.33H8.5v-3.65h4l.39-1H8.5V6h3.33l1.27-3.13H1a1 1 0 0 0-1 1v10.46a1 1 0 0 0 1 1h9.65zm-3.54 0H1v-3.65h6.5zm0-4.65H1V6h6.5z" })));
};
//# sourceMappingURL=Icon.Materialization.js.map